/** 租户流水 /metering/finance/new-fundFlow（fundFlow.vue） */
export default {
  fundFlowPage: {
    phDateStart: '开始日期',
    phDateEnd: '结束日期',
    phTenant: '租户名称/编号',
    phChannel: '交易渠道',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    btnExporting: '导出中...',
    sortDefault: '默认排序',
    ariaFlowTabList: '流水类型',
    ariaFormula: '租户留存公式',
    tabElectric: '电费流水',
    tabWater: '水费流水',
    formulaTotal: '租户留存总额(元)',
    formulaElec: '电费留存金额(元)',
    formulaWater: '水费留存金额(元)',
    sectionElectric: '电费流水',
    sectionWater: '水费流水',
    colId: '流水号',
    colCreateTime: '操作时间',
    colTenant: '租户信息',
    colOperate: '交易类型',
    colChannel: '交易渠道',
    colAmount: '操作金额(元)',
    colBalance: '余额(元)',
    colRemark: '备注',
    colDetail: '明细',
    detailColAmount: '操作金额',
    detailColDeductSub: '抵扣金子账户',
    detailColCashSub: '现金子账户',
    detailRemain: '剩余',
    detailEmpty: '暂无明细数据',
    btnViewDetail: '查看',
    shortcut7: '最近7天',
    shortcut15: '最近15天',
    shortcut30: '最近30天',
    filterAll: '全部',
    filterRowFlowType: '流水类型',
    filterRowDate: '日期',
    filterRowTenant: '租户',
    filterRowChannel: '交易渠道',
    msgNoManagerExport: '缺少项目参数，无法导出',
    msgNoDataExport: '暂无数据可导出',
    msgExportOk: '导出成功！',
    msgExportFail: '导出失败，请重试',
    exportCurrentPage: '导出本页',
    exportSelected: '导出选中',
    exportAll: '导出全部',
    warnNoSelectedExport: '请先选择要导出的数据',
    msgExportOkSelected: '已导出选中 {count} 条',
    successExported: '已导出 {count} 条',
    successExportedLimit: '数据量超过 {total} 条，已导出前 {count} 条',
    exporting: '导出中...',
    msgFetchFail: '获取流水数据失败',
    exportSuffix: '_导出_',
    operateUnknown: '未知',
    operate1: '充值',
    operate2: '退款',
    operate3: '电费',
    operate4: '水费',
    operate5: '服务费',
    operate6: '房屋费',
    operate7: '物业费',
    actionRecharge: '充值',
    actionDeduct: '扣款',
    actionOp: '操作',
    channelVal0: '微信充值',
    channelVal1: '对公充值',
    channelVal2: '手动充值',
    channelVal3: '普通结算',
    channelVal4: '手动扣款',
    channelVal5: '系统补单',
    channelVal6: '浮动电价',
    channelVal7: '分摊结算',
    channelVal8: '余额退款',
    channelVal9: '微信退款',
    channelVal10: '对公退款',
    channelVal11: '设备扣款',
    channelUnknown: '未知'
  }
}
